import PropTypes from 'prop-types';

import themePropTypes from 'core/utils/prop-types/theme';

import withTheme from 'core/hocs/withTheme';
import withBreakpoint from 'core/hocs/withBreakpoint';

import EmptyWrapper from 'core/components/EmptyWrapper';

import styles from './index.styl';


function Concidences(props) {
  const {
    theme: {
      controls: {
        gameCompare: {
          concidences: concidencesAtoms,
          indent: TopicIndent,
        },
      },
    },
    winnerIndex,
    reactionsResult,
    isMobile,
  } = props;

  if (!reactionsResult?.length) return null;

  const Highlight = concidencesAtoms.highlight ? 'b' : 'span';
  const Wrapper = isMobile ? TopicIndent : EmptyWrapper;

  return (
    <Wrapper>
      <style jsx>{`
        .${styles.concidences}
          font ${concidencesAtoms.font}
          color ${concidencesAtoms.color}
          margin ${concidencesAtoms.margin}
      `}</style>
      <div className={styles.concidences}>
        Ваш выбор на <Highlight>{winnerIndex + 1} месте </Highlight>в рейтинге
        и совпал с <Highlight>{Math.round(reactionsResult[winnerIndex].final)}%</Highlight> пользователей!
      </div>
    </Wrapper>
  );
}

Concidences.propTypes = {
  winnerIndex: PropTypes.number,
  reactionsResult: PropTypes.array,
  isMobile: PropTypes.bool,
  theme: themePropTypes(`
    {
      controls: {
        gameCompare: {
          concidences: {
            font,
            color,
            margin,
          },
        },
      },
    },
  `),
};

export default withTheme(withBreakpoint(Concidences));

